import { FC } from "react";

import { ErrorBoundaryQaPanel } from "@ryde/controls";

export const GenerateErrorPanel: FC = () => {
  return <ErrorBoundaryQaPanel />;
};
